module.exports = __webpack_public_path__ + "static/media/footer-logo-@2x.9cdf0a8c.png";